import api from '../../api/index.js'

const state = {
    MemorialHallSearchApiModelList:[]
}

const getters = {

}

const actions = {
    // 获取关注纪念馆列表
    MemorialManageGetHotMemorialHallList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/MemorialManage/GetHotMemorialHallList',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 获取逝者信息
    MemorialManageGetDeceasedInformationList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/MemorialManage/GetDeceasedInformationList',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 设置隐私馆
    MemorialManageSetMemorialHallPrivacyVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/MemorialManage/SetMemorialHallPrivacyVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 保存编辑生平简介
    MemorialManageEditDeceasedLifeVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/MemorialManage/EditDeceasedLifeVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 保存编辑生平简介
    MemorialManageAddMemorialVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/MemorialManage/AddMemorialVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 保存编辑信息
    MemorialManageEditDeceasedInformationVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/MemorialManage/EditDeceasedInformationVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    UpdateMemorialHallTitle({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/MemorialManage/UpdateMemorialHallTitle',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    UpgradeMemorialHallVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/MemorialManage/UpgradeMemorialHallVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    }
    
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}
